/**
 * @generated SignedSource<<57e0a8016db2377a58d2d96c63684490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchTitleRefetchQuery$variables = {
  id: string;
};
export type BrainSearchTitleRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"BrainSearchTitleFragment">;
  } | null;
};
export type BrainSearchTitleRefetchQuery = {
  response: BrainSearchTitleRefetchQuery$data;
  variables: BrainSearchTitleRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrainSearchTitleRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrainSearchTitleFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrainSearchTitleRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "type": "BrainSearch",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "177bec36be3bd5bfcb438b365347b90e",
    "id": null,
    "metadata": {},
    "name": "BrainSearchTitleRefetchQuery",
    "operationKind": "query",
    "text": "query BrainSearchTitleRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...BrainSearchTitleFragment\n    id\n  }\n}\n\nfragment BrainSearchTitleFragment on BrainSearch {\n  id\n  title\n}\n"
  }
};
})();

(node as any).hash = "b5953ae6fad884f9b9f00e9c22977b88";

export default node;
